var _on, _on2, _on3, _on4, _on5, _states;

export var EVENTS = {
  ERROR: 'ERROR',
  FETCH: 'FETCH',
  RESET: 'RESET',
  SUCCESS: 'SUCCESS',
  TIMEOUT: 'TIMEOUT'
};

export var STATES = {
  ERROR: 'error',
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  TIMEOUT: 'timeout'
};

export default {
  initial: STATES.IDLE,
  states: (_states = {}, _states[STATES.IDLE] = {
    on: (_on = {}, _on[EVENTS.FETCH] = STATES.LOADING, _on[EVENTS.SUCCESS] = STATES.SUCCESS, _on[EVENTS.ERROR] = STATES.ERROR, _on)
  }, _states[STATES.LOADING] = {
    on: (_on2 = {}, _on2[EVENTS.TIMEOUT] = STATES.TIMEOUT, _on2[EVENTS.SUCCESS] = STATES.SUCCESS, _on2[EVENTS.ERROR] = STATES.ERROR, _on2)
  }, _states[STATES.TIMEOUT] = {
    on: (_on3 = {}, _on3[EVENTS.FETCH] = STATES.LOADING, _on3[EVENTS.SUCCESS] = STATES.SUCCESS, _on3[EVENTS.ERROR] = STATES.ERROR, _on3)
  }, _states[STATES.SUCCESS] = {
    on: (_on4 = {}, _on4[EVENTS.RESET] = STATES.IDLE, _on4[EVENTS.FETCH] = STATES.LOADING, _on4[EVENTS.SUCCESS] = STATES.SUCCESS, _on4[EVENTS.ERROR] = STATES.ERROR, _on4)
  }, _states[STATES.ERROR] = {
    on: (_on5 = {}, _on5[EVENTS.RESET] = STATES.IDLE, _on5[EVENTS.FETCH] = STATES.LOADING, _on5[EVENTS.SUCCESS] = STATES.SUCCESS, _on5[EVENTS.ERROR] = STATES.ERROR, _on5)
  }, _states)
};